var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('d3-net-example'),_c('ul',{staticClass:"links"},[_c('li',[_c('a',{attrs:{"href":_vm.app.repo}},[_c('div',{staticClass:"icon",domProps:{"innerHTML":_vm._s(_vm.icons.gitHub)}})])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }